import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class UserForgotPasswordService {

  constructor() { }

  // Forgot password OTP Verification API
  async forgotPasswordOtpVerification(email: string) {
    const API_URL: string = environment.baseUrl + environment.apis.verifyForgotPasswordOtp;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'username': email
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  // Update Forgot password API
  async updateForgotPasswordOtpVerification(otp: string, email: string, password: string) {
    const API_URL: string = environment.baseUrl + environment.apis.updateForgotPassword;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'otpcode': otp,
        'username': email,
        'userpassword': password
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}
